<template>
    <b-row>
        <b-col
            v-for="folder in folders"
            :key="folder.id"
            cols="12"
            sm="6"
            lg="3"
            class="mb-3">
            <folder
                v-bind="folder"
                @droppedOn="onDroppedOn"
            />
            <b-tooltip
                :target="`folder-${folder.uuid}`"
                triggers="hover"
                delay="500"
                variant="tooltip-light"
                custom-class="fl-tooltip">
                <span>{{ folder.title }}</span>
            </b-tooltip>
        </b-col>
        <b-col cols="12" sm="6" lg="3">
            <button
                class="border rounded p-3 w-100 bg-transparent"
                @click="$emit('newFolderButtonClicked');"
                id="new-folder-button"
            >
                <fa-icon class="mr-2" :icon="['fas', 'plus']" size="1x"/>
                <span>New Folder</span>
            </button>
            <b-tooltip
                target="new-folder-button"
                triggers="hover"
                delay="500"
                variant="tooltip-light"
                custom-class="fl-tooltip">
                <span>Create a new folder</span>
            </b-tooltip>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: "FolderList",
    props: ["folders", "onFolderMove"],
    methods: {
        onDroppedOn({ sourceType, source, target }) {
            this.$emit('folderDroppedOn', {
                sourceType,
                source,
                target
            });
        }
    }
}
</script>

<style scoped lang="scss">
#new-folder-button {
    &:hover {
        border-color: $brand !important;
    }
}
</style>
